import {
  Option,
  ActivitiesMapLegend,
  Select,
  SingleInfoWindow,
  STATUSPAGE,
  ActivitiesMarkersMap,
  ActivityMarker,
  MarkerGroup,
  ActivityInfoWindow,
} from '@repo/ui';
import {
  GetMapActivityDetails,
  GetMapActivitiesMarkers,
  GetMapInternshipMarkers,
} from 'domain/usecases';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, CardHeader } from 'reactstrap';

interface IDashboardMapsProps {
  updateMapStatus: (value: string) => void;
  mapActivityDetails: GetMapActivityDetails.Result;
  mapActivitiesMarkers: GetMapActivitiesMarkers.Result;
  mapInternshipMarkers: GetMapInternshipMarkers.Result;
  requestGetMapActivityDetails: (params: GetMapActivityDetails.Params) => void;
  loadingMapActivityDetails: STATUSPAGE;
  loadingMapActivitiesMarkers: STATUSPAGE;
  loadingMapInternshipMarkers: STATUSPAGE;
}

export const DashboardMaps = ({
  mapActivityDetails,
  mapActivitiesMarkers,
  mapInternshipMarkers,
  requestGetMapActivityDetails,
  loadingMapActivityDetails,
  loadingMapActivitiesMarkers,
  loadingMapInternshipMarkers,
  updateMapStatus,
}: IDashboardMapsProps) => {
  const [selectedStatusMap, setSelectedStatusMap] = useState<Option>({
    value: '2',
    label: 'Em andamento',
  });
  const [showInternshipLocations, setViewInternshipLocations] =
    useState<boolean>(false);

  const statusOptions: Option[] = [
    {
      value: '1',
      label: 'Não iniciadas',
    },
    {
      value: '2',
      label: 'Em andamento',
    },
    {
      value: '3',
      label: 'Concluídas',
    },
  ];

  const isLoadingActivitiesMarkers =
    loadingMapActivitiesMarkers === STATUSPAGE.LOADING;
  const isLoadingActivityDetails =
    loadingMapActivityDetails === STATUSPAGE.LOADING;
  const isLoadingMap =
    isLoadingActivitiesMarkers ||
    loadingMapInternshipMarkers === STATUSPAGE.LOADING;

  return (
    <Card>
      <CardHeader className="d-flex flex-wrap flex-md-nowrap align-items-center justify-content-between gap-2 pb-2">
        <h5 className="fw-semibold">Georreferenciamento</h5>
        <div className="d-flex flex-wrap flex-md-nowrap justify-content-md-end align-items-center gap-2 w-100">
          {selectedStatusMap && selectedStatusMap.value === '2' && (
            <div className="form-check mb-0">
              <input
                id="showInternshipCheck"
                type="checkbox"
                checked={showInternshipLocations}
                className="form-check-input me-1"
                onChange={(e) => {
                  setViewInternshipLocations(e.target.checked);
                }}
              />
              <label className="form-check-label" htmlFor="showInternshipCheck">
                Exibir Locais de estágio
              </label>
            </div>
          )}

          <div style={{ width: '100%', maxWidth: 260 }}>
            <Select
              onChange={(selected) => {
                setSelectedStatusMap(selected);
                updateMapStatus(selected.value);
              }}
              options={statusOptions}
              value={selectedStatusMap}
            />
          </div>
        </div>
      </CardHeader>
      <CardBody style={{ padding: 0 }}>
        <div style={{ height: 'clamp(300px, 56vh, 620px)' }}>
          {isLoadingMap ? (
            <Skeleton
              count={1}
              style={{ height: '100%' }}
              baseColor="#e8e8e8c5"
              highlightColor="#bababa96"
            />
          ) : (
            <ActivitiesMarkersMap
              zoom={5}
              containerStyle={{ width: '100%', height: '100%' }}
              markerGroups={[
                ...(showInternshipLocations
                  ? [
                      {
                        markerType: 'internship',
                        markers: mapInternshipMarkers as ActivityMarker[],
                        renderInfoWindowContent: (marker: ActivityMarker) => (
                          <SingleInfoWindow info={marker?.name} />
                        ),
                      } satisfies MarkerGroup,
                    ]
                  : []),
                {
                  markerType: 'marker',
                  markers: mapActivitiesMarkers as ActivityMarker[],
                  onMarkerClick: (marker: ActivityMarker) => {
                    requestGetMapActivityDetails({
                      activityhashid: marker.id,
                    });
                  },
                  renderInfoWindowContent: () => {
                    return (
                      <ActivityInfoWindow
                        isLoading={isLoadingActivityDetails}
                        activity={mapActivityDetails}
                      />
                    );
                  },
                },
              ]}
            />
          )}
        </div>
        <div className="p-2">
          <ActivitiesMapLegend />
        </div>
      </CardBody>
    </Card>
  );
};
